import * as React from "react";
import MUITabs from "@mui/material/Tabs";
import MUITab from "@mui/material/Tab";
import MUIBox from "@mui/material/Box";
import SC from "./style";
import useIsMobile from "customHook/useIsMobile";

const NewTab = (props) => {
  const { tabs = [], onChange, selectedValue, children, sx } = props;

  const isMobile = useIsMobile();

  return (
    <>
      <SC.GlobalStyles />
      <MUIBox
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: isMobile ? "column" : "row", // column on mobile
          alignItems: isMobile ? "flex-start" : "center",
        }}
      >
        <MUITabs
          orientation={isMobile ? "vertical" : "horizontal"} // vertical on mobile
          value={selectedValue}
          onChange={onChange}
          sx={{
            ...(isMobile && { width: "100%" }), // make full width on mobile
            ...sx,
          }}
        >
          {tabs.map((tab, index) => (
            <MUITab
              key={index}
              value={tab.value}
              label={tab.label}
              sx={{
                textTransform: "capitalize",
                ...(isMobile && { width: "100%", textAlign: "left" }),
                ...sx,
              }}
            />
          ))}
        </MUITabs>
        {children && <MUIBox sx={{ flex: 1 }}>{children}</MUIBox>}
      </MUIBox>
    </>
  );
};

export default NewTab;
